// extracted by mini-css-extract-plugin
module.exports = {"preview":"Color_preview__3YFoF","invalid":"Color_invalid__232kB"};